export class UpdateTemplateItem {

  constructor(
    public group?: string,   
    public field?: string,
    public isActive?: boolean
  ) {
  }
}


